import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_SITE_FINDS_QUERY } from '../../../gql';
import {
  FindGallery,
  FindGrid,
  useFindResultsState,
} from '../../../components/FindResults';

interface SiteFindsProps {
  findListMode: 'grid' | 'gallery';
}

const SITE_PRESET_OMITTED_KEYS = ['sites'] as const;

const SiteFinds = React.memo(({ findListMode }: SiteFindsProps) => {
  const { siteId } = useParams();
  const galleryMode = findListMode === 'gallery';
  const findResultsState = useFindResultsState();
  const { filter } = findResultsState;
  const { data, loading } = useQuery(GET_SITE_FINDS_QUERY, {
    variables: { siteId, filters: filter },
    fetchPolicy: 'cache-first',
    skip: !siteId,
  });

  const finds = data?.getSiteFinds || [];

  if (galleryMode) {
    return (
      <FindGallery
        finds={finds}
        loading={loading}
        state={findResultsState}
        enableSiteFilter={false}
        presetOmittedKeys={SITE_PRESET_OMITTED_KEYS}
      />
    );
  }

  return (
    <FindGrid
      rows={finds}
      loading={loading}
      state={findResultsState}
      createHref="create"
      enableSiteFilter={false}
      presetOmittedKeys={SITE_PRESET_OMITTED_KEYS}
    />
  );
});

export { SiteFinds };
